import { KeycloakTokenParsed } from 'keycloak-js';

/* Класс реализует обработку дополнительных полей дописываемых в токен. */
export class KeycloakToken implements KeycloakTokenParsed {
	// Список папок модуля Сообщений
	folders: Array<string> = [];
	// Список рабочих столов для модуля Центровки
	workspaces: Array<string> = [];
}
